var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageLast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.797,
    height: 14.523,
    viewBox: "0 0 15.797 14.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.966 -8.214)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.885 8.965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.128,7.261a.748.748,0,0,1-.546-.236L-.546.514A.75.75,0,0,1-.514-.546a.75.75,0,0,1,1.06.032L6.674,6a.75.75,0,0,1-.546,1.264Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.261a.747.747,0,0,1-.514-.2A.75.75,0,0,1-.546,6L5.582-.514a.75.75,0,0,1,1.06-.032A.75.75,0,0,1,6.674.514L.546,7.025A.748.748,0,0,1,0,7.261Z",
    transform: "translate(0 6.511)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.716 8.964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.128,7.261a.748.748,0,0,1-.546-.236L-.546.514A.75.75,0,0,1-.514-.546a.75.75,0,0,1,1.06.032L6.674,6a.75.75,0,0,1-.546,1.264Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.261a.747.747,0,0,1-.514-.2A.75.75,0,0,1-.546,6L5.582-.514a.75.75,0,0,1,1.06-.032A.75.75,0,0,1,6.674.514L.546,7.025A.748.748,0,0,1,0,7.261Z",
    transform: "translate(0 6.511)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLast);
export default __webpack_public_path__ + "static/media/page-last.9e1fba08.svg";
export { ForwardRef as ReactComponent };